var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Video Sermons")]),_c('h2',{staticClass:"h1"},[_vm._v("Jerry's Uploads")])])],1)],1),_c('b-container',[_c('b-row',{staticClass:"px-5"},[_c('video-list',{attrs:{"playlistId":"PL4i1fmTD7kZVLuAw2gzwOrncw5X8zLSu_","playlistTitle":"Jerry's Uploads"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }